import React from "react";
import { useParams } from "react-router-dom";
// import PageBradcrume from "../PageBradcrume";
import { ServiceCatWise, SingleCatName } from "../FetchAPI";
import ServiceBox from "./ServiceBox";
// import BradcrumeSection from "../Others/BradcrumeSection";
import LegalBradcrumeSection from "../Community/LegalBradcrumeSection";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
// import PageBanner2 from "../PageBanner2";

export default function Service() {
  let { category } = useParams();
  const { RendomTokenfetch } = useAuth();
  const [ServiceCat] = ServiceCatWise(RendomTokenfetch, category);
  const [CatNamesigle] = SingleCatName(RendomTokenfetch, category);
  // console.log(CatNamesigle);
  return (
    <>
      <Helmet>
        <title>{CatNamesigle.catname}</title>
        <meta name="description" content={""} />
        <meta name="keywords" content={""} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* 
      <BradcrumeSection
        Pagename={CatNamesigle.catname}
        page1={[
          { name: "Services", pagelink: "services" },
          { name: CatNamesigle.catname },
        ]}
      /> */}

      <LegalBradcrumeSection
        Pagename={CatNamesigle.catname}
        page1={[
          { name: "Services", pagelink: "services" },
          { name: CatNamesigle.catname },
        ]}
      />

      <section
        className={`job-categories section_padding_top section_padding_bottom`}
      >
        <div className="auto-container">
          {/* <div className="sec-title text-center">
          <h2>{ServiceCat.category}</h2>
          </div> */}
          <div className="row wow fadeInUp">
            {ServiceCat &&
              ServiceCat.map((value, index) => (
                <ServiceBox
                  key={index}
                  title={value.title}
                  slug_url={value.service_slug}
                  icon_image={value.image}
                />
              ))}
          </div>
        </div>
      </section>
    </>
  );
}
